import type { ConversationId } from "@redotech/effect-api-shared/ids/definitions";
import type { ConversationStatus } from "@redotech/effect-api-shared/models/shopper-ai/conversation/conversation";
import { RedoListDropdown } from "@redotech/redo-web/arbiter-components/list/redo-list-dropdown";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import { useStatusSelector } from "../hooks/use-status-selector";
import { StatusBadge } from "./badges/conversation-badges";
import { ConversationTicketFieldTitle } from "./conversation-ticket-field-title";

export const StatusSelector = memo(function StatusSelector({
  conversationId,
  status,
}: {
  conversationId: ConversationId;
  status: ConversationStatus;
}) {
  const {
    statusListItems,
    dropdownOpen,
    badgeRef,
    setBadgeRef,
    handleBadgeClick,
    handleDropdownOpenChange,
    handleItemSelected,
  } = useStatusSelector({ conversationId });

  return (
    <Flex align="center" gap="xs" justify="space-between">
      <ConversationTicketFieldTitle>Status</ConversationTicketFieldTitle>
      <Flex cursor="pointer" onClick={handleBadgeClick} ref={setBadgeRef}>
        <StatusBadge status={status} />
      </Flex>
      <RedoListDropdown
        dropdownAnchor={badgeRef}
        dropdownOpen={dropdownOpen}
        fitToAnchor={false}
        items={statusListItems}
        itemSelected={({ item }) => handleItemSelected(item.value)}
        selectedItems={`status-${status.toLowerCase()}`}
        selectionVariant="none"
        setDropdownOpen={handleDropdownOpenChange}
        size="xs"
      />
    </Flex>
  );
});
